import React from "react";

export default function TeamMemberCard({ member }) {
  const { name, role, bio, initials, image, linkedin } = member;

  return (
    <article className="team-card">
      <div className="team-card-avatar" aria-hidden="true">
        {image ? (
          <img src={image} alt="" className="team-card-photo" />
        ) : (
          <span className="team-card-initials">{initials}</span>
        )}
      </div>
      <h3 className="heading-4 team-card-name">{name}</h3>
      <p className="team-card-role">{role}</p>
      <p className="body-small team-card-bio">{bio}</p>
      {linkedin && (
        <a
          href={linkedin}
          target="_blank"
          rel="noopener noreferrer"
          className="team-card-link"
        >
          LinkedIn →
        </a>
      )}
    </article>
  );
}
